import React from "react";

export default function() {
  const style = {
    width: "42%",
    top: "45%",
    left: "29%",
    position: "absolute",
    textAlign: "center"
  };

  console.log("server missing render");

  return (
    <div style={style}>
      We are upgrading our panel.
      <br />
      Your email are working perfectly and soon you will be able to use the panel.
      <br />
      <a onClick={() => document.location.replace("login")}>refresh</a>
    </div>
  );
}
